
import {typesUsercreddet} from './svtypes/usercreddet'


/*
import {typesUsercreddet} from '../svtypes/reguserdet'
//http://svabode-1420502022.us-west-1.elb.amazonaws.com/account/addressDetail
//POST http://localhost:8080/account/addressDetail
http://localhost:8086/account/addressDetail
rq
{
 "id":3
}



*/
let initStore = {
    loading: false,
    error: false,
   
    errob :{
      "timestamp": "2015-08-23T02:27:18.038+0000",
      "status": 500,
      "error": "Default Error",
      "message": "500 null",
      "path": "/kk/svaddressDetailPost"
  },
    my_data_geo:{
        "countryTypes": [
            {
                "name": "United STates America",
                "a2": "US",
                "a3": "USA",
                "value": "USA",
                "isonum": "840"
            },
            {
                "name": "Canada",
                "isdcode": "01",
                "a2": "CA",
                "a3": "CAN",
                "value": "CAN",
                "isonum": "124"
            }
        ],
        "stateTypes": [
            {
                "name": "California",
                "value": "CA",
                "a2": "CA"
            },
            {
                "name": "New York",
                "value": "NY",
                "a2": "NY"
            },
            {
                "name": "Texas",
                "value": "TX",
                "a2": "TX"
            }
        ],
        "isdcodeTypes": [
            {
                "name": "United States Of America(+1)",
                "value": "1"
            },
            {
                "name": "Australia(+61)",
                "value": "61"
            },
            {
                "name": "Spain(+34)",
                "value": "34"
            }
        ],
        "genderTypes": [
            {
                "name": "CL_MALE",
                "value": "MALE"
            },
            {
                "name": "CL_FEMALE",
                "value": "FEMALE"
            }
        ]
    },
    my_data_usercreddet: {
        "id": -1,
        "username": "pet123@yahoo.com",
        "password": "pet123"
    },
    my_data_profile:{
        "id": -11,
        "username": "",
        "password": "",
        "addressId": -1,
        "customerId": -1,
        "name": "",
        "fname": "",
        "lname": "",
        "phone": "",
        "email": "",
        "login": "SVDEFAULT_NO_USER",
       
        "otherDetails": "",
        "city": "",
        "state": "",
        "country": "usa",
        "address": null,
        "zipcode": "",
        "isdcode": "1",
        "token":"ssDEFAULT",
        "MMtokenBAK": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXltZW50TWV0aG9kQ29kZSI6ImNhcmQiLCJuYW1lIjoiam9uYiIsImZuYW1lIjoiam9uIiwibG5hbWUiOiJiZXRhIiwicGhvbmUiOiI1MTIxMjM0MzIyIiwiZW1haWwiOiJqb25AeWFob28uY29tIiwiYWRkcmVzcyI6IjEyIGxpbnZvYyIsImxvZ2luIjoiam9uQHlhaG9vLmNvbSIsInBhc3N3b3JkIjoiUGV0ZTEyMyIsInBhc3N3b3JkbWlycm9yIjoiUGV0ZTEyMyIsImVuY3Bhc3N3b3JkIjoiUGV0ZTEyMyIsIm90aGVyRGV0YWlscyI6Ik5lZWQgcGlja3VwIiwiaXNkY29kZSI6IjEiLCJjdXN0b21lcklkIjo3LCJjcmVhdGVkQnkiOiJBYm9kZVN5c3RlbUFkbWluIiwibW9kaWZpZWRCeSI6IkFib2RlU3lzdGVtQWRtaW4iLCJjcmVhdGVkRGF0ZSI6IjIwMjQtMDctMTNUMDE6NDk6MzQuMDAwKzAwMDAiLCJtb2RpZmllZERhdGUiOiIyMDI0LTA3LTEzVDAxOjQ5OjM0LjAwMCswMDAwIiwiaWF0IjoxNzI0MjEwMjE4LCJleHAiOjE3MjQyMTM4MTh9.y29VFr0Ixli6xRJizR2-kqYvf5PEFMtxbM4s3WUJquc",

        "addressType": "B",
        "createdDate": null,
        "modifiedDate": null,
        "createdBy": null,
        "modifiedBy": null
    }
   
}

export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
        case 'RESETFORM_SAVEUSERCRED_SUCCESS':
            console.log("reduce %%%%%%%%RESETFORM_SAVEUSERCRED_SUCCESS  success*****************");
            console.log(action.payload.my_data_usercreddet);
            // let januState = {...state, loading: false, my_data_usercreddet: action.payload.my_data_usercreddet}
             januState = {...state,error:false ,loading: false, my_data_usercreddet: action.payload.my_data_usercreddet}
            return januState
        case 'GET_SAVEUSERCRED_SUCCESS':
            console.log("reduce %%%%%%%%evsearcg  success*****************");
            console.log(action.payload.my_data_profile);
            if(action && action.payload && action.payload.my_data_geo){
                console.log("reduce %%%%%%%%evsearcg  success and geos *****************");
                januState = {...state, loading: false,error:false, my_data_geo: action.payload.my_data_geo ,my_data_profile: action.payload.my_data_profile}
           

            }else{
                console.log("reduce %%%%%%%%evsearcg  success and NP GEO *****************");
                
                januState = {...state, loading: false,error:false, my_data_profile: action.payload.my_data_profile}
           

            }
            // let januState = {...state, loading: false, my_data_usercreddet: action.payload.my_data_usercreddet}
            return januState
        case typesUsercreddet.GET_SAVEUSERCRED_CUSTOM_SUCCESS:
                console.log("logout")
                januState = {...state, loading: false,error:false,  my_data_profile: action.payload.my_data_profile}
                return januState
        case typesUsercreddet.GET_SAVEUSERCRED_BEGIN:
            console.log("loading")
            return {...state, loading: true}
        case typesUsercreddet.GET_SAVEUSERCRED_LOGOUT:
                console.log("logout")
                januState = {...state,error:false,  loading: false, my_data_profile: action.payload.my_data_profile}
                return januState
        case 'GET_SVPROFILEALL_ERROR':
                    console.log("error")
                    console.log(action.payload.errob)
                    const errjson = {
                        "timestamp": "2024-08-23T02:27:18.038+0000",
                        "status": 500,
                        "error": "Internal Server Error",
                        "message": "500 null",
                        "path": "/accountclient/svaddressDetailPost"
                    }
                    return {...state,errob:action.payload.errob, error: true}
             
        case typesUsercreddet.GET_SAVEUSERCRED_ERROR:
            console.log("error")
            return {...state, error: true}
        default:
            return state
    }
}